// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.recalls.UpdatePatientRecallRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdatePatientRecallRequest extends GandalfModelBase {

	@GandalfLabel('Comments')
	@GandalfValidator({ sizeString: { message: 'Comments cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfLabel('Recall Reason')
	@GandalfValidator({ notNull: { message: 'Recall Reason is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	encounterTemplateId!: number;

	@GandalfLabel('Patient Recall')
	@GandalfValidator({ notNull: { message: 'Patient Recall is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientRecallId!: number;

	@GandalfLabel('Recall Location')
	@GandalfProperty({ designType: Number })
	practiceLocationId!: number | null;

	@GandalfLabel('Recall Date')
	@GandalfValidator({ notNull: { message: 'Recall Date is required' } })
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date, isRequired: true })
	recallDate!: Date;

}
